import { GalleryVerticalEnd } from "lucide-react";
import { createFileRoute } from "@tanstack/react-router";
import { Button } from "../components/shad/button";
import { SignupForm } from "../features/login/signup-form";

import homeImage from "@/assets/phone-frame.svg";

export const Route = createFileRoute("/")({
  component: Index,
});

function Index() {
  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex justify-center gap-2 md:justify-start">
          <a href="#" className="flex items-center gap-2 font-medium">
            <div className="bg-primary text-primary-foreground flex size-6 items-center justify-center rounded-md">
              <GalleryVerticalEnd className="size-4" />
            </div>
            Flightlocker
          </a>
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-sm">
            <SignupForm />
            home
          </div>
        </div>
      </div>
      <div className="bg-zinc-50 items-center justify-center relative h-screen hidden lg:flex">
        <img src={homeImage} alt="Image" className="block" />
      </div>
    </div>
  );
}
